/* eslint-disable jsx-a11y/interactive-supports-focus */
import React, { Dispatch, SetStateAction, useState, useRef, useEffect, useContext } from 'react';

import { useNavigate, useParams } from 'react-router-dom';
import QRCode from 'react-qr-code';
import Swal from 'sweetalert2';

import { ICustomerData, IServiceData } from 'src/environments/CheckoutConsultantAPP/interfaces';
import { apiCheckoutConsultant } from 'src/environments/CheckoutConsultantAPP/api';
import ConsultantCheckoutContext from 'src/contexts/consultantCheckout';

import Cronometer from './components/Cronometer';

import {
  ButtonModifyMethod,
  ContainerIconMethod,
  ContainerMethodSelected,
  ContainerPix,
  ContainerQrCode,
  CopyIcon,
  IconPix,
  LoadingGif,
  PixButtonContainer,
  PixButtonCopy,
} from './style';

import pixWhiteSVG from '../../../../../../../../assets/images/outfits-montage-icons/pix-white.svg';
import copyIconSVG from '../../../../../../../../assets/images/outfits-montage-icons/copy-icon.svg';
import loadingGIF from '../../../../../../../../assets/gifs/loading.png';

type Props = {
  customerData: ICustomerData;
  serviceData: IServiceData;
  setShowPaymentMethod: Dispatch<SetStateAction<string>>;
};

export default function PurchasePaymentPix({
  customerData,
  serviceData,
  setShowPaymentMethod,
}: Props): JSX.Element {
  const { fullAppointmentData } = useContext(ConsultantCheckoutContext);

  const [qrCode, setQrCode] = useState({ QR_CODE: '', transactionId: '' });
  const [loading, setLoading] = useState(true);
  const [copy, setCopy] = useState(false);
  const [intervalId, setIntervalId] = useState<NodeJS.Timer>();

  const navigate = useNavigate();

  const { token } = useParams();

  const getPixPaymentInfo = (): void => {
    const interval = setInterval(async () => {
      const transactionPaid = await apiCheckoutConsultant.checkPaymentStatus(
        serviceData.customerAppointmentId
      );

      if (transactionPaid) {
        clearInterval(interval);
        navigate(`/pagamento-concluido/servico-consultora/${token}`);
      }
    }, 5000);
    setIntervalId(interval);
  };

  const getQrCode = async (): Promise<void> => {
    try {
      setLoading(true);
      const currentDate = new Date();
      currentDate.setDate(currentDate.getDate() + 1);

      const consultantServiceData = {
        ...customerData,
        customerPhone: customerData.customerPhone.replace(/[^a-zA-Z0-9]/g, '').replace(' ', ''),
        customerCpf: customerData.customerCpf.replace(/[^a-zA-Z0-9]/g, ''),
        zipCode: customerData.zipCode.replace('-', ''),
        ...serviceData,
      };

      const data = await apiCheckoutConsultant.createPixOrder(consultantServiceData);

      setQrCode(data);
      if (data.transactionId) {
        getPixPaymentInfo();
      }
      setLoading(false);
    } catch (e) {
      void Swal.fire({
        icon: 'error',
        title: 'Erro na geração do pix!',
        text: 'Por favor, faça o pagamento por cartão de crédito',
        iconColor: 'black',
        confirmButtonColor: 'black',
      });
      setShowPaymentMethod('');
    }
  };

  const shouldLog = useRef(true);

  useEffect(() => {
    if (shouldLog.current) {
      shouldLog.current = false;

      if (fullAppointmentData.paymentStatus === 'Aprovado') {
        void Swal.fire({
          icon: 'error',
          title: 'Esse link já foi pago!',
          text: 'Por favor, entre em contato com sua consultora para confirmar o pagamento!',
          iconColor: 'black',
          confirmButtonColor: 'black',
        });
      } else {
        void getQrCode();
      }
    }
  }, []);

  const handleClickCopy = (): void => {
    void navigator.clipboard.writeText(qrCode.QR_CODE);
    setCopy(true);
    setTimeout(() => {
      setCopy(false);
    }, 3000);
  };

  return (
    <ContainerPix>
      <ContainerMethodSelected>
        <ContainerIconMethod>
          <IconPix src={pixWhiteSVG} alt="Ícone do pix branco" />
          <p>PIX</p>
        </ContainerIconMethod>
        <ButtonModifyMethod
          onClick={() => {
            setShowPaymentMethod('');
            clearInterval(intervalId);
          }}
        >
          Modificar
        </ButtonModifyMethod>
      </ContainerMethodSelected>
      {loading ? (
        <LoadingGif src={loadingGIF} alt="Loading spinning" />
      ) : (
        <>
          {qrCode.QR_CODE !== '' && (
            <PixButtonContainer>
              <p>
                Clique no código abaixo e utilize o Pix Copia e Cola no aplicativo que você vai
                fazer o pagamento:
              </p>
              <PixButtonCopy onClick={handleClickCopy}>
                {copy ? (
                  <span>Copiado!</span>
                ) : (
                  <>
                    {qrCode.QR_CODE.slice(0, 35)}...
                    <CopyIcon src={copyIconSVG} alt="copiar e colar" />
                  </>
                )}
              </PixButtonCopy>
              <ContainerQrCode>
                <Cronometer intervalId={intervalId} setShowPaymentMethod={setShowPaymentMethod} />
                <QRCode value={qrCode.QR_CODE} />
              </ContainerQrCode>
            </PixButtonContainer>
          )}
        </>
      )}
    </ContainerPix>
  );
}
